import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';
import { unknownHasOwnPropertyTS } from '@components/utils';
import { handleLogout} from '@features/authentication/authFunctions';



export const authMiddleware: Middleware = () => (next) => (action) => {
	
	if (isRejectedWithValue(action) && typeof action.type === 'string' && /^baseApi\/[\w]*\/rejected$/.test(action.type)) {

		// exceptions
		if (action.meta.arg && unknownHasOwnPropertyTS(action.payload, 'status') && action.payload.status === 401) {
			console.warn('Api call rejected with 401 - Unauthorized');
			console.warn({ error: action.error });
			console.warn({ meta: action.meta });
			console.warn({ payload: action.payload });
			console.warn({ type: action.type });

			console.warn('Clear all auth tokens from storage')
			handleLogout();
		}
	}
	return next(action);
}